import type { ColTypeDef, ValueFormatterParams } from 'ag-grid-community';
import { useSPIntl } from 'hooks/useIntl';
import { useMemo } from 'react';

import {
  defaultFilterOptions,
  makeDateFilterComparatorWithParser,
  makeGridDateSortComparatorWithParser,
  parseDate,
} from './utils';

export function useDateColumnType<T>(): ColTypeDef<T> {
  const { formatDisplayedDate } = useSPIntl();
  return useMemo(
    () => ({
      comparator: makeGridDateSortComparatorWithParser(parseDate),
      valueFormatter: ({ value }: ValueFormatterParams) => (value ? formatDisplayedDate(new Date(value)) : ''),
      filter: 'agDateColumnFilter',
      filterParams: {
        comparator: makeDateFilterComparatorWithParser(parseDate),
        filterOptions: defaultFilterOptions,
        inRangeInclusive: true,
      },
    }),
    [formatDisplayedDate],
  );
}

export function useServerSideDateColumnType<T>(): ColTypeDef<T> {
  const { formatDisplayedDate } = useSPIntl();
  return useMemo(
    () => ({
      comparator: makeGridDateSortComparatorWithParser(parseDate),
      valueFormatter: ({ value }: ValueFormatterParams) => (value ? formatDisplayedDate(new Date(value)) : ''),
    }),
    [formatDisplayedDate],
  );
}
